var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.subgroups),function(subgroup,index){return [(subgroup.documents.length)?[_c('collapse',{key:index,class:_vm.$style.collapse,attrs:{"title":subgroup.title,"isInitialOpen":subgroup.isOpened}},_vm._l((subgroup.documents),function(doc,docIndex){return _c('router-link',{key:docIndex,class:_vm.$style.subgroup,attrs:{"active-class":_vm.$style._active,"to":{
            name: 'document-page',
            params: {
              projectSlug: _vm.$route.params.projectSlug,
              documentSlug: doc.slug
            }
          }}},[_vm._v("\n          "+_vm._s(doc.title)+"\n        ")])}),1)]:_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }